// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectProcessType-module__selectProcessTypeContainer--DzSxk {\n  padding: 2rem;\n}", "",{"version":3,"sources":["webpack://./src/react/features/OrderFlow/steps/SelectProcessType.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".selectProcessTypeContainer {\n  padding: 2rem;\n  // 今後、プレビューエリアと選択エリアを分けるためのスタイルなどを追加する\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectProcessTypeContainer": "SelectProcessType-module__selectProcessTypeContainer--DzSxk"
};
export default ___CSS_LOADER_EXPORT___;
